// @flow

import {useTranslation} from "react-i18next";
import {useStore} from "./useStore";

// Acente rolü kapıda ödeme özelliğini VigoPOS marka adıyla değil,
// müşteriye dönük "Kapıda Ödeme" adıyla tanıyor.
export const useCodPaymentBrandLabel = () => {
    const stores = useStore();
    const {t} = useTranslation(["common"]);
    return stores.meStore.checkRole("isAgency")
        ? t("codPaymentBrand.agency", {ns: "common"})
        : t("codPaymentBrand.default", {ns: "common"});
};
